import Logo from "@/components/brand/Logo";
import { Link } from "react-router-dom";
import { useState } from "react";
import { AnalyticsPreference } from "@/analytics/AnalyticsPreference";

export default function MarketingFooter() {
  const [showPrefs, setShowPrefs] = useState(false);
  return (
    <footer className="border-t border-white/10 bg-navy-900 text-ivory-200 px-6 sm:px-12 lg:px-24 py-16" data-testid="marketing-footer">
      <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2">
          <Logo variant="light" />
          <p className="mt-4 text-sm text-ivory-200/70 max-w-sm leading-relaxed">
            TrendRise AI is an AI-powered organic growth platform for ecommerce, SaaS, agencies, creators, courses, and local businesses. Turn trends into compounding revenue.
          </p>
          <p className="mt-4 text-xs text-ivory-200/50">© {new Date().getFullYear()} TrendRise AI. All rights reserved.</p>
        </div>

        <div>
          <p className="editorial-overline">Product</p>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/pricing" className="hover:text-gold-500" data-testid="footer-pricing">Pricing</Link></li>
            <li><Link to="/login" className="hover:text-gold-500" data-testid="footer-demo">Demo dashboard</Link></li>
            <li><Link to="/signup" className="hover:text-gold-500" data-testid="footer-signup">Start free</Link></li>
          </ul>
        </div>

        <div>
          <p className="editorial-overline">Resources</p>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/#features" className="hover:text-gold-500" data-testid="footer-features">Features</Link></li>
            <li><span className="text-ivory-200/50 cursor-default">Changelog (soon)</span></li>
            <li><span className="text-ivory-200/50 cursor-default">Documentation (soon)</span></li>
            <li>
              <button onClick={() => setShowPrefs((v) => !v)} className="hover:text-gold-500 text-left" data-testid="footer-cookie-preferences">
                Cookie preferences
              </button>
            </li>
          </ul>
        </div>
      </div>
      {showPrefs && (
        <div className="max-w-7xl mx-auto mt-10 border-t border-white/10 pt-6" data-testid="footer-cookie-preferences-panel">
          <div className="max-w-lg">
            <p className="editorial-overline">Cookie preferences</p>
            <div className="mt-3"><AnalyticsPreference dark /></div>
          </div>
        </div>
      )}
    </footer>
  );
}
